import { render, staticRenderFns } from "./ParametroForm.vue?vue&type=template&id=89085d04&"
import script from "./ParametroForm.vue?vue&type=script&lang=js&"
export * from "./ParametroForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports